<template>
  <div id="top-section">
    <div id="nav" :style="styleObject">
      <b-container>
        <b-navbar toggleable="lg" type="light">
          <!-- Left aligned nav items -->
          <b-navbar-nav id="left-nav-items">
            <b-navbar-brand
              to="/"
              v-scroll-to="{ el: '#swiper-header', offset: -53 }"
            >
              <img src="@/assets/logos/logo_T-red.svg" alt="Rangers logo" />
            </b-navbar-brand>
            <div v-if="!isMobile" id="v-line"></div>
            <img
              v-if="!isMobile"
              class="globelife"
              src="@/assets/logos/logo_GLF-colour.svg"
              alt="Globe Life Field"
            />
          </b-navbar-nav>
          <div class="items">
            <b-nav-item
              v-if="isMobile"
              id="book-now-button"
              to="/"
              v-scroll-to="{ el: '#BookSuite', offset: -60 }"
              >Contact Us</b-nav-item
            >
            <a
              v-if="isMobile"
              class="bookButton"
              href="https://flex2.seasonshare.com/texasrangers_suites/purchase_seats?purchaseSeatTab=find_games"
              target="_blank"
              >Buy Now</a
            >
          </div>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <!-- Center aligned nav items -->
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="mx-auto" v-b-scrollspy>
              <b-nav-item
                to="/"
                v-scroll-to="{ el: '#swiper-header', offset: -53 }"
                >Home</b-nav-item
              >
              <b-nav-item
                to="/suite-rentals/"
                v-scroll-to="{ el: '#swiper-header', offset: -53 }"
                >Suite Rentals</b-nav-item
              >
              <b-nav-item
                to="/season-suites/"
                v-scroll-to="{ el: '#swiper-header', offset: -53 }"
                >Season Suites</b-nav-item
              >
              <b-nav-item
                to="/ways-to-use/"
                v-scroll-to="{ el: '#swiper-header', offset: -53 }"
                >Ways to Use</b-nav-item
              >
              <b-nav-item
                id="schedule-nav-link"
                to="/suite-rentals/"
                v-scroll-to="{ el: '#Schedule', offset: -10 }"
                >2026 Schedule</b-nav-item
              >
            </b-navbar-nav>
          </b-collapse>

          <!-- Right aligned nav items -->
          <b-navbar-nav v-if="!isMobile">
            <b-nav-item
              id="book-now-button"
              to="/"
              v-scroll-to="{ el: '#BookSuite', offset: -100 }"
              >Contact Us</b-nav-item
            >
            <a
              class="bookButton"
              href="https://flex2.seasonshare.com/texasrangers_suites/purchase_seats?purchaseSeatTab=find_games"
              target="_blank"
              >Buy Now</a
            >
          </b-navbar-nav>
        </b-navbar>
      </b-container>
    </div>
    <div id="call-bar">
      <b-container>
        <div id="number-section">
          <img src="@/assets/icons/icon_phone.svg" alt="Phone" />
          <a href="tel:9727264377p3">972-RANGERS (X3)</a>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      whiteWidth: this.calcWhiteWidth(),
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.whiteWidth = this.calcWhiteWidth();
      this.windowWidth = window.innerWidth;
    },
    calcWhiteWidth() {
      return 0.467489 * window.innerWidth - 318.4357;
    },
  },
  computed: {
    styleObject() {
      return this.windowWidth <= 992
        ? `background: white`
        : this.windowWidth <= 1600 
        ? `background: linear-gradient(to right, white ${this.whiteWidth}px, #000 ${this.whiteWidth}px)`
        : `background: linear-gradient(to right, white ${this.whiteWidth}px, #000 ${this.whiteWidth}px)`;
    },
    isMobile() {
      return this.windowWidth <= 992;
    },
  },
};
</script>

<style lang="scss" scoped>
#nav {
  @media only screen and (max-width: $lg) {
    background: linear-gradient(white 53px, $dark-blue 53px);
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  .navbar {
    padding: 5px 0;
    &-nav {
      display: flex;
      flex-direction: row;
      align-items: center;
      @media only screen and (min-width: $xl) {
        gap: 15px;
      }
      @media only screen and (max-width: $lg) {
        flex-direction: column;
      }
    }
    #nav-collapse {
      @media only screen and (max-width: $lg) {
        height: 100vh;
        width: 100vw;
        ul {
          margin: 50% 0;
          li:not(:last-child) {
            margin-bottom: 10%;
          }
          a {
            width: 135px;
            line-height: 22px;
          }
        }
      }
    }
  }
  .globelife {
    margin-left: 18px;
  }
  a {
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0;
    font-weight: 500;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.3);
    @media only screen and (max-width: $lg) {
      color: #000;
      font-family: "BertholdCondensed";
      font-weight: 700;
      font-size: 25px;
    }
  }
  a.is-active {
    color: #fff;
    @media only screen and (max-width: $lg) {
      color: $rangers-red;
    }
  }
  #left-nav-items {
    align-items: center;
    #v-line {
      height: 30px;
      width: 1px;
      background-color: $grey;
    }
  }
  .call {
    font-size: 13px;
    line-height: 18px;
    font-weight: 500;
    letter-spacing: 0;
    color: #ffffff;
    margin-right: 17px;
    white-space: nowrap;
    a:hover {
      text-decoration: none;
    }
  }
  #book-now-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 120px;
    border-radius: 8px;
    border: none;
    background-color: #51D074;
    line-height: 15px;
    text-transform: uppercase;
    white-space: nowrap;
    @media only screen and (max-width: $xl) {
      margin-right: 10px;
    }
    @media only screen and (max-width: $lg) {
      margin-left: 10px;
      width: 85px;
    }
    a {
      color: #ffffff;
      font-family: "Gotham";
      font-weight: 900;
      font-size: 11px;
      @media (max-width: $sm) {
        font-size: 8px;
      }
    }
  }
  .items {
    display: flex;
    flex-direction: row;
  }
  .bookButton {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 120px;
    border-radius: 8px;
    border: none;
    background-color: #2d984b;
    line-height: 15px;
    text-transform: uppercase;
    white-space: nowrap;
    color: #ffffff;
    font-family: "Gotham";
    font-weight: 900;
    font-size: 11px;
    @media only screen and (max-width: $lg) {
      margin-left: 10px;
    }
    @media (max-width: $md) {
      margin-left: 5px;
      width: 90px;
    }
    @media (max-width: $sm) {
      margin-left: 0;
      width: 60px;
      font-size: 8px;
    }
  }
  #schedule-nav-link {
    a {
      color: rgba(255, 255, 255, 0.3);
      @media only screen and (max-width: $lg) {
        color: #fff;
      }
    }
  }
}
#call-bar {
  display: block;
  position: fixed;
  z-index: 11;
  width: 100%;
  left: 0px;
  top: 53px;
  height: auto;
  height: auto;
  text-align: center;
  pointer-events: none;
  cursor: default;
  //background: rgba(4, 12, 24, 0.3);
  background: linear-gradient(
    90deg,
    rgba(4, 12, 24, 0) 0%,
    rgba(4, 12, 24, 0) 50%,
    #040c18 100%
  );
  //backdrop-filter: blur(10px);
  transition: 0.5s;
  #number-section {
    img {
      margin: 0 10px;
    }
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 30px;
    font-weight: 500;
    font-size: 13px;
    a {
      color: #fff;
    }
  }
}

.container {
  @media screen and (min-width: 1600px) {
    max-width: 1500px;
  }
}
</style>
